import styled from '@emotion/styled';
import CSS from 'csstype';
import {
  background,
  BackgroundProps,
  border,
  BorderProps,
  color,
  compose,
  display,
  DisplayProps,
  flexbox,
  FlexboxProps,
  GridProps,
  layout,
  LayoutProps,
  position,
  PositionProps,
  ShadowProps,
  space,
  SpaceProps,
  textAlign,
  TextAlignProps,
  typography,
  TypographyProps,
} from 'styled-system';
import {
  ColorProps,
  CoreBaseProps,
  defineWithTheme,
  shouldForwardProp,
} from '../../theming';
import React from 'react';

export interface BaseParagraphProps
  extends CoreBaseProps,
    BackgroundProps,
    BorderProps,
    ColorProps,
    DisplayProps,
    FlexboxProps,
    GridProps,
    LayoutProps,
    PositionProps,
    ShadowProps,
    SpaceProps,
    TextAlignProps,
    TypographyProps {
  textDecoration?: CSS.Property.TextDecoration;
}

export type ParagraphProps = React.PropsWithRef<BaseParagraphProps>;

export const P = styled('p', {
  shouldForwardProp: (prop) =>
    shouldForwardProp<BaseParagraphProps>(prop as keyof BaseParagraphProps),
})<ParagraphProps>(
  ({ textDecoration = 'none' }) => `
      text-decoration: ${textDecoration};
      margin: 0;
      padding: 0;
      border: 0;
    `,
  defineWithTheme('paragraphs'),
  compose(
    background,
    border,
    color,
    display,
    flexbox,
    layout,
    position,
    space,
    textAlign,
    typography
  )
);
